/* request/index.js */

/* 封装 axios 请求 */
import { axios, NProgress, Base_Api_Url, store } from "@plugins";

// 创建 axios 实例
const request = axios.create({
  // 接口地址
  baseURL: Base_Api_Url,
  // 请求超时时间
  timeout: 60000,
  // 设置请求头
  headers: {
    "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
  },
});

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    // 进度条 开始
    NProgress.start();

    // 加Token
    if (store.state.admin.adminInfo.token) {
      config.headers["Token"] = store.state.admin.adminInfo.token;
    }

    return config;
  },
  (error) => {
    // 进度条 结束
    NProgress.done();

    // 打印报错信息
    console.log("request error: " + error);

    return Promise.reject(error);
  }
);

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 进度条关闭
    NProgress.done();

    // 核心逻辑：判断response.data是否为Blob类型
    if (response.data instanceof Blob) {
      return response;
    }

    // 响应状态码为 200 且 data 存在时返回 data
    if (response.status === 200 && response.data.status) {
      response.data.message = response.data.msg;

      response.data.code = response.data.status;

      delete response.data.msg;

      delete response.data.status;

      // 判断返回 code 状态码
      const { code, message, data } = response.data;

      return response;
    } else {
      response.data = {
        code: response.status,
        message: response.statusText,
        data: [],
      };

      return response;
    }
  },
  (error) => {
    // 进度条关闭
    NProgress.done();

    error.data = {
      code: 500,
      message: error.message,
      data: [],
    };

    return error.data;
  }
);

// 封装 GET 请求
const get = async (url, params = {}) => {
  let { data } = await request.get(url, { params });

  return data;
};

// 封装 POST 请求
const post = async (url, params = {}) => {
  let { data } = await request.post(url, params);

  return data;
};

/**
 * 上传文件
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const upload = async (url, params) => {
  let { data } = await request.post(url, params, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return data;
};

/**
 * downloadFile
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
const downloadFile = async (url, params = {}) => {
  const result = await request.get(url, {
    params,
    responseType: "blob",
  });

  return result;
};

const postFile = async (url, params = {}) => {
  const result = await request.post(url, params, {
    responseType: "blob",
  });

  return result;
};

export { get, post, upload, downloadFile, postFile };
